import { ReduxStore } from '../types';

export function selectBackground(store: ReduxStore) {
    const layoutConfig = store.config.layout;

    return layoutConfig.background;
}
